import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'

import cart from './module/cart'
import item from './module/item'
import user from './module/user'
import customer from './module/customer'
import order from './module/order'
import home from './module/home'
import blog from './module/blog'
import itemSmell from './module/item-smell'

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [createPersistedState({ storage: window.sessionStorage })],
    modules: {
        cart,
        item,
        itemSmell,
        user,
        customer,
        order,
        home,
        blog
    }
})
